import rolesApi from "../../api/permissionsApi";

const state = { permissions: undefined, permissionsUser: undefined };

const actions = {
    groupPermissions({ commit }) {
        return new Promise((resolve, reject) => {
            rolesApi
                .groupPermissions()
                .then((response) => {
                    if (response.status === 200) {
                        commit("SET_PERMISSION", response.data);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    permissionsUser({commit}, userId) {
        return new Promise((resolve, reject) => {
            rolesApi
                .permissionsUser(userId)
                .then((response) => {
                    if (response.status === 200) {
                        commit("SET_PERMISSIONS_USER", response.data);
                        resolve(response)
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                })
        })
    }
}
const mutations = {
    SET_PERMISSION: (state, permissions) => (state.permissions = permissions),
    SET_PERMISSIONS_USER: (state, permissions) => (state.permissionsUser = permissions)
};
export default { state, actions, mutations };